import { QueryKeys, useEntities } from "@/api/core";
import { useGroupRelationship } from "@/api/group-relationships";
import { useLocalStorage } from "@/hooks";
import { accountSchema } from "@/schemas";
import { GroupRoles } from "@/schemas/group-member";

function useGroupMembershipRequests(groupId: string) {
  const { groupRelationship: relationship } = useGroupRelationship(groupId);

  const [totalCount, setTotalCount] = useLocalStorage<number>(
    String(QueryKeys.accounts.groupMembershipRequests(groupId)),
    0,
  );

  const queryInfo = useEntities({
    queryKey: QueryKeys.accounts.groupMembershipRequests(groupId),
    endpoint: `/api/v1/groups/${groupId}/membership_requests`,
    schema: accountSchema,
    enabled:
      (!!groupId && relationship?.role === GroupRoles.OWNER) ||
      relationship?.role === GroupRoles.ADMIN,
    getTotalCount(count) {
      setTotalCount(count);
    },
  });

  return {
    ...queryInfo,
    totalCount,
  };
}

export { useGroupMembershipRequests };
